import { ChevronLeft, ChevronRight } from "lucide-react";
import { photoUrl } from "./InstagramConnect";

const DOT = { draft: "bg-brand-tertiary", scheduled: "bg-sky-500", publishing: "bg-amber-500", published: "bg-emerald-500", failed: "bg-rose-500" };
export const STATUS_LABEL = { draft: "Draft", scheduled: "Scheduled", publishing: "Posting…", published: "Posted", failed: "Failed" };

const key = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

export function SocialCalendar({ month, setMonth, posts, onOpen }) {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const start = new Date(first); start.setDate(1 - first.getDay());
  const days = [...Array(42)].map((_, i) => { const d = new Date(start); d.setDate(start.getDate() + i); return d; });
  const byDay = {};
  posts.filter((p) => p.scheduled_at).forEach((p) => { const k = key(new Date(p.scheduled_at)); (byDay[k] = byDay[k] || []).push(p); });
  const today = key(new Date());

  return (
    <div className="rounded-xl border border-brand-border bg-brand-surface overflow-hidden" data-testid="social-calendar">
      <div className="flex items-center justify-between px-5 py-3 border-b border-brand-border">
        <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))} data-testid="cal-prev" className="p-1 rounded hover:bg-brand-hover"><ChevronLeft className="h-4 w-4" /></button>
        <p className="font-serif text-xl text-brand-ink" data-testid="cal-month">{month.toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>
        <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))} data-testid="cal-next" className="p-1 rounded hover:bg-brand-hover"><ChevronRight className="h-4 w-4" /></button>
      </div>
      <div className="grid grid-cols-7 text-[10px] uppercase tracking-[0.14em] text-brand-tertiary border-b border-brand-border">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d} className="px-2 py-2">{d}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {days.map((d) => {
          const k = key(d);
          const inMonth = d.getMonth() === month.getMonth();
          return (
            <div key={k} className={`min-h-[96px] border-b border-r border-brand-border p-1.5 ${inMonth ? "" : "bg-brand-page/60"}`}>
              <p className={`text-[11px] mb-1 ${k === today ? "inline-flex h-5 w-5 items-center justify-center rounded-full bg-brand-ink text-brand-page" : inMonth ? "text-brand-muted" : "text-brand-tertiary"}`}>{d.getDate()}</p>
              <div className="space-y-1">
                {(byDay[k] || []).map((p) => (
                  <button key={p.id} onClick={() => onOpen(p)} data-testid={`cal-post-${p.id}`}
                    className="w-full flex items-center gap-1.5 rounded-md bg-brand-page hover:bg-brand-hover p-1 text-left transition-colors">
                    <img src={photoUrl(p.photo_ids[0], true)} alt="" className="h-7 w-6 rounded object-cover shrink-0" />
                    <span className="min-w-0 flex-1">
                      <span className="block text-[10px] text-brand-ink">{new Date(p.scheduled_at).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}</span>
                      <span className="flex items-center gap-1 text-[9px] text-brand-tertiary"><span className={`h-1.5 w-1.5 rounded-full ${DOT[p.status]}`} />{STATUS_LABEL[p.status]}</span>
                    </span>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
